import { css } from "@/utils/css";
import { v4 as uuid } from "uuid";

type SwitchProps = {
    id?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
};

export function Switch({ checked, onChange, id, disabled }: SwitchProps) {
    const uniqueId = id || uuid();

    return (
        <label htmlFor={uniqueId} className={css("toggle-switch")}>
            <input
                id={uniqueId}
                type="checkbox"
                className={css("toggle-input")}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            />
            <span className={css("toggle-slider", disabled ? "disabled" : "")}></span>
        </label>
    );
}

type SwitchBoxProps = SwitchProps & {
    label: string;
    help?: string | React.ReactNode;
    className?: string;
};

export function SwitchBox({ checked, onChange, label, help, className, disabled, ...props }: SwitchBoxProps) {
    const id = uuid();

    return (
        <label htmlFor={id} className={css("switch-box", className)} {...props}>
            <div>
                <span className={css("label")}>{label}</span>
                {help && <p className={css("description")}>{help}</p>}
            </div>
            <Switch id={id} checked={checked} onChange={onChange} disabled={disabled} />
        </label>
    );
}
